import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import InformationcircleIcon from 'icons/Informationcircle.icon';
import { RadioOption } from 'components/RadioGroupField/RadioGroupField.component';
import ResolvePopup from 'components/ResolvePopup';

function useGeneralRules() {
  const { t } = useTranslation();

  const immediatelyAcceptLabel = useMemo(
    () => (
      <p className="general-rules-label">
        <span>{t('immediatelyAcceptVerifiedBuyers')}</span>

        <ResolvePopup
          onHover
          popupContent={t('immediatelyAcceptVerifiedBuyersDesc')}
        >
          <InformationcircleIcon />
        </ResolvePopup>
      </p>
    ),
    [t],
  );

  return useMemo<RadioOption<string>[]>(
    () => [
      {
        label: immediatelyAcceptLabel,
        value: 'immediatelyAcceptVerifiedBuyers',
      },
    ],
    [immediatelyAcceptLabel],
  );
}

export default useGeneralRules;
